module.exports = __webpack_public_path__ + "img/spacing.78a08fef.webp";